<template>
  <div ref="listRef" class="overflow-y-auto h-full learn-class-wrapper">
    <TopBanner
      :pageBackground="pageBackground"
      :pageTitle="pageTitle"
      :pageSubTitle="pageSubTitle"
    />
    <div class="mx-auto pb-[36px] learn-class mt-[48px]">
      <div
        class="flex-1 pb-[30px]"
        :class="{
          'mt-[60px]': !isChinese(),
        }"
      >
        <a-spin :spinning="loading" class="flex flex-col">
          <div v-if="displayList.length" class="series-list pb-[30px] series-cn">
            <CategoryTutorial
              v-for="(item, index) in displayList"
              :key="index"
              :category="item"
              :isAcademy="true"
              :isSingle="displayList.length <= 1"
              class="mb-[28px]"
              @onMore="goLink(item)"
            />
          </div>
        </a-spin>
      </div>
    </div>
    <Footer v-if="!isChinese()" :retractable="true" />
  </div>
</template>
<script setup lang="ts" name="Activity">
import { getClassSeries, getPromotionCenterPageCard } from '@/api';
import type { ISeriesClass } from '~/api/interface/class';
import { PAGE_CARD_TYPE } from '~/api/interface/publicize';
import { PageKey } from '~/constants/page';
import Footer from '~/design/widgets/bottom-footer/footer-en.vue';
import { isChinese } from '~/utils/area';
import TopBanner from '../academy/banner.vue';
import CategoryTutorial from './components/category.vue';

const listRef = ref();

const loading = ref(false);
const total = ref(0);

provideResourceLocation({
  source: SOURCE.Tutorial,
});

useBackToTop(() => ({
  scrollContainer: '.learn-class-wrapper',
  item: '.card-item',
  total: total.value,
}));

const { data } = useAsyncData('classSeries', () => getClassSeries({ many: 1 }));

const displayList = computed(() => {
  return (data.value?.data || []) as ISeriesClass[];
});

const router = useRouter();

// 系列视频跳转
const goLink = (record: ISeriesClass) => {
  trackEvent(TRACK_EVENT.CLICK_TUTORIAL_PLAY, {
    series_id: record.id,
    series_title: record.title,
    source: SOURCE.Tutorial,
    position: '教程集合页-系列', // @xi18n-ignore
  });
  router.push({
    name: PageKey.TUTORIAL_INFO,
    params: { id: record.guide_video_info?.[0].id },
  });
};

const { data: pageData } = useAsyncData('promotionCenterPageCard', async () => {
  const res = await getPromotionCenterPageCard({
    type: PAGE_CARD_TYPE.TUTORIAL,
  });
  return res.data;
});

const pageTitle = computed(() => pageData.value?.[0].title);
const pageSubTitle = computed(() => pageData.value?.[0].sub_title);
const pageBackground = computed(() => pageData.value?.[0].cover_url);
</script>

<style lang="scss" scoped>
.learn-class-wrapper {
  display: block !important;
  :deep(.ant-spin-nested-loading) {
    @apply h-full;
    .ant-spin-container {
      @apply h-full;
    }
  }
  :deep(.card-item) {
    .description {
      display: none;
    }
    &:hover {
      .name {
        display: none;
      }
      .description {
        display: block;
      }
    }
  }

  .title-sticky {
    @apply bg-back-1 left-0 top-0 sticky;
    padding: 15px 0px 20px;
    z-index: 12;
  }
  .learn-class {
    padding-bottom: 0;
    @apply flex flex-col;
  }
}

.series-list {
  display: grid;
  width: 1400px;
  margin: 0 auto;
  grid-template-columns: repeat(2, 1fr);
  // grid-auto-rows: 262px;
  grid-auto-flow: dense;
  gap: 14px;
  &.series-cn {
    width: 1200px;
    display: block;
  }
}
</style>
